import { render } from "./scenario-share.vue?vue&type=template&id=0b339d5e&scoped=true&ts=true"
import script from "./scenario-share.vue?vue&type=script&lang=ts"
export * from "./scenario-share.vue?vue&type=script&lang=ts"

import "./scenario-share.vue?vue&type=style&index=0&id=0b339d5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b339d5e"]])

export default __exports__